/**
 * String utility functions for formatting and transforming text
 */

/** Canonical display/storage width for workplace unit numbers. */
export const WORKPLACE_UNIT_NUMBER_DIGITS = 4;

/**
 * Pads a workplace unit number (or numeric id used as one) to 4 digits.
 * Non-digit characters are stripped before padding.
 */
export const formatWorkplaceUnitNumber = (
	value: string | number | null | undefined
): string => {
	if (value == null || value === '') return '';
	const digits = String(value).replace(/\D/g, '');
	if (!digits) return String(value).trim();
	return digits.padStart(WORKPLACE_UNIT_NUMBER_DIGITS, '0');
};

/**
 * Capitalizes the first letter of each word in a string.
 * Also replaces underscores with spaces.
 * 
 * @param value - The string to capitalize
 * @returns The capitalized string with underscores replaced by spaces
 * 
 * @example
 * capitalizeWords('in_progress') // returns 'In Progress'
 * capitalizeWords('pending_review') // returns 'Pending Review'
 * capitalizeWords('completed') // returns 'Completed'
 */
export const capitalizeWords = (value: string): string => {
	if (!value) return value;
	
	return value
		.replace(/_/g, ' ') // Replace underscores with spaces
		.split(' ') // Split by spaces
		.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
		.join(' '); // Join back together
};
